import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL ?? '';
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY ?? '';

/**
 * Which required config is missing, or null when everything is present.
 *
 * CRA bakes REACT_APP_* into the bundle at build time, so "missing" here always
 * means the build was wrong, never that something failed at runtime.
 *
 * This used to be a console.error followed by `createClient('', '')`, which
 * throws at module load — React never mounted and the page rendered white under
 * a clean HTTP 200. That shipped to roamoir.ardentlabs.io on 2026-08-27 and
 * every signal (200, valid TLS, healthy pod, bundle downloading) said the site
 * was fine while it was dead. The Dockerfile now refuses to build without these
 * values, so this path should be unreachable in a deployed image; it stays as a
 * second line of defence, and because `npm start` with a missing .env.local hits
 * exactly the same case.
 */
export const missingConfig: string[] = [
  ...(supabaseUrl ? [] : ['REACT_APP_SUPABASE_URL']),
  ...(supabaseAnon ? [] : ['REACT_APP_SUPABASE_ANON_KEY']),
];

export const isConfigured = missingConfig.length === 0;

/**
 * Placeholders keep `createClient` from throwing at module load. They are only
 * ever reached when `isConfigured` is false, and the app renders the
 * configuration screen instead of any route that would use this client.
 */
export const supabase = createClient(
  supabaseUrl || 'https://unconfigured.invalid',
  supabaseAnon || 'unconfigured',
);
